<template>
  <WsText001 h4>
    {{ value }}
  </WsText001>
</template>

<script>
export default {
  name: "WsInfoText",
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
  },
};
</script>